export enum CookieGroup {
  REQUIRED = 'C0001',
  LEISTUNGS_COOKIES = 'C0002',
  FUNKTIONALE_COOKIES = 'C0003',
  MARKETING_COOKIES = 'C0004'
}
